import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { ValueStrategyModule } from 'src/app/operational-data-common/feature-pipes/value-strategy-based/value-strategy-module';
import { ReferenceRoomSettingsService } from '../service/reference-room-settings.service';
import { RoutingService, UIService } from '@services';

import {
  SingleRoomControlOverlayTypeEnum,
  SingleRoomControlUrlTypeEnum,
} from '../../../installation-overlay.model';
import { ReferenceRoomSettingsHelper } from '../reference-room-settings.helper';

import { FeaturePropertyKey } from '@vi-iot/client/index';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-reference-room-settings-manage-room',
  standalone: true,
  imports: [CommonStandaloneModule, MatButtonModule, MatIconModule, ValueStrategyModule],
  templateUrl: './reference-room-settings-manage-room.component.html',
  styleUrl: './reference-room-settings-manage-room.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceRoomSettingsManageRoomComponent implements OnInit {
  readonly FeaturePropertyKey = FeaturePropertyKey;

  @Input() gatewaySerial: string;

  channelEntity$: Observable<ReferenceRoomSettingsHelper.RoomsChannelsEntityData>;

  constructor(
    public rrsService: ReferenceRoomSettingsService,
    private routingService: RoutingService,
    private uiService: UIService
  ) {}
  ngOnInit(): void {
    this.channelEntity$ = this.rrsService.getRoomsChannelsEntityDataForHeatingCircuit();
  }

  goToRoomAssignment(): void {
    this.rrsService.setView(ReferenceRoomSettingsHelper.ReferenceRoomSettingsView.AssignRoom);
  }

  goToRoomDetails(room: string): void {
    this.uiService.closeActiveOverlay();
    const params = { [ReferenceRoomSettingsHelper.queryParamRoom]: room };
    this.uiService.openSingleRoomControlOverlay(
      SingleRoomControlOverlayTypeEnum.SingleRoomControlCommissioning
    );
    this.routingService.addChildPathToUrl(SingleRoomControlUrlTypeEnum.Commissioning, params);
  }
}
